import {
  browserTracingIntegration,
  consoleLoggingIntegration,
  init,
  tanstackRouterBrowserTracingIntegration,
} from '@sentry/react'
import type { Register } from '@tanstack/react-router'

export const initSentry = (router: Register['router']) => {
  init({
    dsn: import.meta.env.VITE_ANALYSER_SENTRY_DSN,
    enableLogs: true,
    environment: import.meta.env.VITE_DEPLOY_ENV,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 1.0,
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    ignoreErrors: ['Transition was skipped', 'Transition was aborted'],
    integrations: [
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      browserTracingIntegration(),
      tanstackRouterBrowserTracingIntegration(router),
      consoleLoggingIntegration({
        levels: ['log', 'warn', 'error', 'info'],
      }),
    ],
    // Enable logs to be sent to Sentry
    tracePropagationTargets: [import.meta.env.VITE_API_URL],
  })
}
